import {
    Dialog,
    DialogContent,
    DialogContentText,
    Divider,
    Grid
} from '@mui/material';
import { useTheme } from '@mui/styles';
import { CancelButtonGrey } from '@tassat/button';
import { Failure as FailureIcon, Hourglass, Success as SuccessIcon } from '@tassat/icon';
import { muiTheme } from '@tassat/payments-themes';
import { AlertTypes } from '@tassat/ui-definitions';
import * as React from 'react';

import muiStyles from './styles';
import { AlertModalProps } from './types';

export default function AlertModal(props: AlertModalProps) {
    const {
        type,
        open,
        title,
        Body,
        onClose
    } = props;
    const classes = muiStyles(props);
    const theme = useTheme<typeof muiTheme>();

    const renderIcon = () => {
        if (type === AlertTypes.success) {
            return (
                <SuccessIcon
                    className={classes.icon}
                    iconColor={theme?.app?.applicationColors.success || '#26A69A'}
                />
            );
        }

        if (type === AlertTypes.failure) {
            return (
                <FailureIcon
                    className={classes.icon}
                    iconColor={theme?.app?.applicationColors.failureDark || '#AD3D4B'}
                />
            );
        }

        if (type === AlertTypes.timeout) {
            return (
                <Hourglass
                    className={classes.icon}
                    iconColor={theme?.app?.applicationColors.failureDark || '#AD3D4B'}
                />
            );
        }

        return null;
    };

    const renderTitle = () => {
        if (title) {
            return title;
        }

        if (type === AlertTypes.success) {
            return 'Success';
        }

        if (type === AlertTypes.failure) {
            return 'Failure';
        }

        if (type === AlertTypes.timeout) {
            return 'Timed Out';
        }

        return 'Info';
    };

    return (
        <Dialog
            classes={{ paperWidthXl: classes.paperWidthXl }}
            disableEscapeKeyDown
            maxWidth='xl'
            onClose={(event, reason) => {
                if (reason === 'backdropClick') return;
                onClose();
            }}
            open={open}
            transitionDuration={{
                enter: 0,
                exit: 0
            }}
        >
            <Grid
                className={classes.root}
                container
                direction='column'
                spacing={0}
                wrap='nowrap'
            >
                <Grid
                    className={classes.title}
                    container
                    item
                    justifyContent='center'
                    spacing={0}
                    xs={12}
                >
                    <Grid
                        container
                        direction='row'
                        item
                        spacing={0}
                        wrap='nowrap'
                        xs={11}
                    >
                        {renderIcon()}
                        <Grid
                            className={classes.titleText}
                            item
                            xs={11}
                        >
                            {renderTitle()}
                        </Grid>
                    </Grid>
                    <Grid
                        className={classes.cancelButton}
                        item
                        xs={1}
                    >
                        <CancelButtonGrey onClick={onClose} />
                    </Grid>
                </Grid>
                <Divider variant='middle' />
                <Grid
                    item
                    xs={12}
                >
                    <DialogContent>
                        {
                            typeof Body === 'string' ?
                                <DialogContentText>{Body}</DialogContentText>
                                : <div>{Body}</div>
                        }
                    </DialogContent>
                </Grid>
            </Grid>
        </Dialog>
    );
}